
import { Box, CircularProgress, Typography } from "@mui/material"




export const CargandoMedio = ({ titulo }) => {


  return (
    <Box sx={{ display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', width:'100%', height:'100%' }}>
        <CircularProgress size="50px" />
        <Typography sx={{fontSize:18, mt:1, textAlign:'center'}} >{ titulo }</Typography>
    </Box>

  )
}
